import React from "react";
import Terminal from "./Terminal.js";

function App() {
  return (
    <div>
      <Terminal />
    </div>
  );
}

export default App;
